import React, { useState } from "react";
import { Button, Col, Form, Input, notification, Row } from "antd";
import AuthService from "../../base/services/authentication.service";
import { httpService } from "../../base/services/httpService.service";
import VerificationCodeModal from "../VerificationCodeModal/VerificationCodeModal";

import "../VerificationCodeModal/VerificationCodeModal.scss";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";



const UpdateEmail = () => {
   const user = AuthService.getUser();
   const [form] = Form.useForm();
   const [isLoading, setIsLoading] = useState(false);
   const [validateConfirmationCodeModal, setValidateConfirmationCodeModal] = useState(false);
   const { executeRecaptcha } = useGoogleReCaptcha();

   const onFinish = async (values) => {
      if(!executeRecaptcha){
         return;
      }

      setIsLoading(true);

      const recaptchaToken = await executeRecaptcha('login');

      httpService
         .post(
            "/account/sendUpdateEmailCode",
            {
               userId: user.id,
               newEmail: values.newEmail
            },
            (res) => {
               if (res?.isSuccess) {
                  setValidateConfirmationCodeModal(true);
                  notification.success({
                     message: "A verification code has been sent to your email."
                  });
               } else if (res?.errors) {
                  notification.error({
                     message: "There was an error updating the email. Please try again."
                  });
               }
            },
            () => {},
            undefined,
            {
               'g-recaptcha-response' : recaptchaToken
            }
         )
         .catch((error) => {
            notification.error({
               message:
                  (Array.isArray(error.response.data.errors) &&
                     error.response.data.errors.join(", ")) ||
                  "Something went wrong. Please try again."
            });
         })
         .finally(() => {
            setIsLoading(false);
         });
   };

   const onComplete = async (code) => {
      if(!executeRecaptcha) {
         return;
      }

      setIsLoading(true);

      const recaptchaToken = await executeRecaptcha('login');
      await httpService
         .post(
            "/Account/confirmEmail",
            {
               userId: user.id,
               code
            },
            (response) => {
               if (response?.isSuccess) {
                  httpService
                     .post(
                        "/Account/updateEmail",
                        {
                           userId: user.id,
                           newEmail: form.getFieldValue("newEmail")
                        },
                        (response) => {
                           if (response?.isSuccess) {
                              notification.success({
                                 message: "Your email has been updated successfully."
                              });
                              setValidateConfirmationCodeModal(false);
                              AuthService.logout();
                           }
                        }
                     )
                     .catch((error) => {
                        notification.error({
                           message:
                              (Array.isArray(error.response.data.errors) &&
                                 error.response.data.errors.join(", ")) ||
                              "There was an error updating the email. Please try again."
                        });
                     })
                     .finally(() => {
                        setIsLoading(false);
                     });
               }
            },() => {},
            undefined,
            {
               'g-recaptcha-response': recaptchaToken
            }
         )
         .catch((error) => {
            notification.error({
               message:
                  (Array.isArray(error.response.data.errors) &&
                     error.response.data.errors.join(", ")) ||
                  "Something went wrong. Please try again."
            });
            setIsLoading(false);
         });
   };

   const onCancel = () => {
      setIsLoading(false);
      setValidateConfirmationCodeModal(false);
   };

   return (
      <>
         <Form form={form} onFinish={onFinish} autoComplete="off" layout="vertical">
            <p className="label-text mt-8 mb-5">
               To update your email, please enter your current email, your new email, and confirm
               the new email address.
            </p>
            <Row gutter={24}>
               <Col xs={24} sm={12}>
                  <Form.Item label={<span className="label-text">Email</span>} name="email">
                     <Input defaultValue={user.email} disabled />
                  </Form.Item>
               </Col>
               <Col xs={24} sm={12}>
                  <Form.Item
                     label={<span className="label-text">New email</span>}
                     name="newEmail"
                     rules={[
                        {
                           required: true,
                           message: "Please enter your new email!"
                        },
                        {
                           pattern: /^[a-zA-Z][a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                           message: "Please enter a valid email address"
                        }
                     ]}
                  >
                     <Input placeholder="Type your new email" />
                  </Form.Item>
               </Col>
               <Col xs={24} sm={12}>
                  <Form.Item
                     label={<span className="label-text">Confirm email</span>}
                     name="confirmEmail"
                     dependencies={["newEmail"]}
                     rules={[
                        { required: true, message: "Please confirm your new email!" },
                        ({ getFieldValue }) => ({
                           validator(_, value) {
                              if (!value || getFieldValue("newEmail") === value) {
                                 return Promise.resolve();
                              }
                              return Promise.reject(new Error("The two emails do not match!"));
                           }
                        })
                     ]}
                  >
                     <Input placeholder="Confirm your new email" />
                  </Form.Item>
               </Col>
            </Row>
            <Row gutter={16} className="mt-8" align="middle">
               <Col>
                  <Button htmlType="submit" className="primaryButton" loading={isLoading}>
                     Update
                  </Button>
               </Col>
            </Row>
         </Form>
         {validateConfirmationCodeModal && (
            <VerificationCodeModal
               isVisible={validateConfirmationCodeModal}
               onComplete={onComplete}
               onCancel={onCancel}
               isLoading={isLoading}
               email={form.getFieldValue("newEmail")}
               updateType="email"
            >
               <hr />
               <p className="description">
                  If you haven't received the email, click{" "}
                  <strong onClick={() => onFinish(form.getFieldsValue())}>
                     Resend verification code
                  </strong>
               </p>
            </VerificationCodeModal>
         )}
      </>
   );
};

export default UpdateEmail;
